import { PanelType } from '@fluentui/react';
import { concatStyleSets, DefaultButton, DetailsList, getTheme, IconButton, PrimaryButton, SelectionMode, Text, TextField } from 'office-ui-fabric-react';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { addDays } from 'office-ui-fabric-react/lib/utilities/dateMath/DateMath';
import React, { Component, Fragment } from 'react';
import Scriba from 'react-scriba';
import { DataEcheancier, IDS_ECHEANCIERS } from '../../../data/DataEcheancier';
import { Immocom } from '../../../specifique/immocom';
import { ComboBoxEcheancier } from '../../ComboBox/ComboBoxEcheancier';
import { EUIDatePicker } from '../../EUI/EUIDatePicker';
import { EUIDialog } from '../../EUI/EUIDialog';
import { EUIPanel } from '../../EUI/EUIPanel';
import { EUISeparator } from '../../EUI/EUISeparator';
import { EUITextField } from '../../EUI/EUITextField';
import { ProgressIndicatorChargement } from '../../Loader/ProgressIndicatorChargement';
import { MessageBars } from '../../Outils/MessageBars';
import { EUIPercentField } from '../../EUI/EUIPercentageField';
import { DialogNomStade } from './DialogNomStade';
import { StadeForm } from './StadeForm';
import { MaxLengths } from '../../../data/MaxLenghts';

export class FicheEcheancier extends Component {

    static STEPS = {
        SELECTION: 1,
        EDITION: 2,
    };

    static defaultProps = {
        isOpen: false,
        idEcheancier: null,
        idOperation: null,
        /* --- */
        onDismiss: (reload) => null,
        onEnregistrement: () => null
    };

    static defaultState = {
        currentStep: FicheEcheancier.STEPS.SELECTION,
        echeancier: {},
        idEcheancierTypeSelectionne: 0,
        itemActif: {},
        reloadOnDismiss: false, // Passé en paramètre à props.onDismiss, permet le rechargement des données onDismiss uniquement si on modifie le nom d'un stade
        stades: [],
        /* --- */
        onActiveBoutonEnregistrer: false,
    };

    _theme = getTheme();

    constructor(props) {
        super(props);
        this.state = { ...FicheEcheancier.defaultState };
        this.deferredValidation = window.setTimeout(null);
    };

    _ajouterStade = (stade) => {
        const { idOperation, idEcheancier } = this.props;
        let stades = [...this.state.stades, { ...stade, idOperation, idEcheancier }];
        stades = this._recalculerTaux(stades);
        stades = this._determinerRangeDatePrevisionnelle(stades);
        this.setState({
            stades,
            minDatePrevisionnelle: null,
            maxDatePrevisionnelle: null,
        }, this._onVerificationFormulaire);
    };

    _chargementDonnees = () => {
        const { idOperation, idEcheancier } = this.props;
        const { idEcheancierTypeSelectionne } = this.state;

        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Chargement de l'échéancier en cours..."
        });

        if (idEcheancierTypeSelectionne === IDS_ECHEANCIERS.NEW) {
            const currentStep = FicheEcheancier.STEPS.EDITION;
            const echeancier = { idOperation };
            const stades = [];
            Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, { currentStep, echeancier, stades }, this._onVerificationFormulaire);
        }
        else {
            const inclureEcheancierAuxEchanciersLies = !!idEcheancierTypeSelectionne; // Si on se base sur un modèle alors on inclue le modèle aux échéanciers liés
            DataEcheancier._chargementEcheancier(idOperation, idEcheancier || idEcheancierTypeSelectionne, inclureEcheancierAuxEchanciersLies)
                .then(responseFetch => {
                    const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
                    if (retourVerif === null) {
                        const reponseAPIobjet = responseFetch.reponseAPIobjet || {};
                        const estFicheOuverteEnModeCreation = this._estFicheOuverteEnModeCreation();

                        let echeancier = reponseAPIobjet.echeancier || {};
                        if (estFicheOuverteEnModeCreation) {
                            echeancier.idEcheancier = null;
                            echeancier.nomEcheancier = "";
                        }

                        let stades = reponseAPIobjet.stades || [];
                        stades = stades.map(stade => {
                            const { datePrevisionnelle, dateReelle, pourcentageCumul, pourcentageCumulType } = stade;
                            return {
                                ...stade, idOperation, idEcheancier,
                                datePrevisionnelle: !!datePrevisionnelle && datePrevisionnelle.slice(-1).toUpperCase() !== "Z" ? `${datePrevisionnelle}Z` : datePrevisionnelle,
                                dateReelle: estFicheOuverteEnModeCreation ? null : dateReelle,
                                pourcentageCumul: pourcentageCumul || pourcentageCumulType || 0,
                            };
                        });

                        stades = this._recalculerTaux(stades);
                        stades = this._determinerRangeDatePrevisionnelle(stades);

                        const state = {
                            currentStep: FicheEcheancier.STEPS.EDITION,
                            echeancier: { ...echeancier, idOperation },
                            stades
                        };
                        Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, state, this._onVerificationFormulaire);
                    }
                    else Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
                });
        }
    };

    _determinerRangeDatePrevisionnelle = (stades) => {
        let maxDatePrevisionnelle = null;
        stades.sort((a, b) => b.pourcentageCumul - a.pourcentageCumul); // Ordre décroissant
        stades = stades.map((stade, index) => {
            stade.maxDatePrevisionnelle = maxDatePrevisionnelle;
            maxDatePrevisionnelle = stade.datePrevisionnelle || maxDatePrevisionnelle;
            return stade;
        });

        const now = new Date(Date.now());
        const aujourdhui = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()));
        const demain = addDays(aujourdhui, 1);
        let minDatePrevisionnelle = demain;
        stades.sort((a, b) => a.pourcentageCumul - b.pourcentageCumul); // Ordre croissant
        return stades.map((stade, index) => {
            stade.minDatePrevisionnelle = minDatePrevisionnelle;
            minDatePrevisionnelle = stade.datePrevisionnelle || minDatePrevisionnelle;
            return stade;
        });
    };

    _enregistrer = () => {

        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Enregistrement de l'écheancier en cours..."
        });

        const { idOperation, onEnregistrement } = this.props;
        const { echeancier, stades } = this.state;

        DataEcheancier._onEnregistrementEcheancier(echeancier, stades, idOperation)
            .then(responseFetch => {
                const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
                if (retourVerif === null) {
                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, { ...FicheEcheancier.defaultState }, onEnregistrement);
                }
                else Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
            });

    };

    _estFicheOuverteEnModeCreation = () => {
        return !this.props.idEcheancier;
    };

    _estFicheOuverteEnModeModification = () => {
        return !!this.props.idEcheancier;
    };

    _getColumns = () => {
        let columns = [
            {
                isResizable: true,
                key: "nomStade",
                name: "Stade",
                onRender: (item) => <Stack horizontal verticalAlign="center">
                    <Text>{item.nomStade}</Text>
                    {item.stadeType && <Text variant="tiny" styles={{ root: { color: this._theme.palette.themePrimary, paddingLeft: "3px", alignSelf: "baseline" } }}>type</Text>}
                    {!item.stadeType && !item.estNouveauStade && !item.dateReelle &&
                        <IconButton
                            ariaLabel="Modifier le libellé du stade"
                            iconProps={{
                                iconName: "Edit",
                                styles: { root: { fontSize: ".9rem" } }
                            }}
                            onClick={this._toggleDialog("NomStade", true, item, null)}
                            size="small"
                            title="Modifier le libellé du stade"
                        />
                    }
                </Stack>
            },
            {
                key: "autresEcheanciersLies",
                minWidth: 100,
                maxWidth: 100,
                name: "Autres éch. liés",
                onRender: (item) => {
                    let title = "";
                    let nbEcheanciersLies = 0;
                    if (!!item.autresEcheanciersLies) {
                        nbEcheanciersLies = item.autresEcheanciersLies.length;
                        title = item.autresEcheanciersLies.reduce((memo, echeancier, index) => {
                            const { estStadeAvance, nomEcheancier } = echeancier;
                            memo += nomEcheancier;
                            if (estStadeAvance) memo += " (av. travaux effectué)";
                            if (index < nbEcheanciersLies) memo += "\r\n";
                            return memo;
                        }, "");
                    }
                    const text = `${nbEcheanciersLies} échéancier${nbEcheanciersLies > 1 ? "s" : ""}`;
                    return <span title={title} className="badge badge-secondary" style={{ cursor: "help" }}>{text}</span>;
                }
            },
            {
                key: "pourcentageAvancementTravaux",
                minWidth: 100,
                maxWidth: 100,
                name: "Avancement",
                onRender: (item) => <span>{parseFloat(item.pourcentageAvancementTravaux * 100).toFixed(10)}&nbsp;%</span>
            },
            {
                key: "pourcentageCumul",
                minWidth: 175,
                maxWidth: 175,
                name: "Cumul",
                onRender: (item) => {
                    const { autresEcheanciersLies, dateReelle, pourcentageCumul } = item;
                    // La modification du pourcentage cumulé est désactivée s'il existe un avancement travaux sur cet échéancier, ou sur n'importe quel autre échéancier de l'opération utilisant ce stade
                    const disabled = !!dateReelle || (!!autresEcheanciersLies && Array.isArray(autresEcheanciersLies) && autresEcheanciersLies.some(echeancier => echeancier.estStadeAvance));
                    return <EUIPercentField
                        disabled={disabled}
                        onChange={() => this.setState({ onActiveBoutonEnregistrer: false })}
                        onDelayedChange={this._onDelayedChange(item)}
                        scale={10}
                        value={pourcentageCumul * 100}
                    />;
                }
            },
            {
                key: "datePrevisionnelle",
                minWidth: 150,
                maxWidth: 150,
                name: "Date prévisionnelle",
                onRender: (item) => {
                    const { datePrevisionnelle, dateReelle, idStade, minDatePrevisionnelle, maxDatePrevisionnelle } = item;
                    return <EUIDatePicker
                        data-testid="datePrevisionnelleEcheancier"
                        disabled={!!dateReelle && !!dateReelle}
                        onSelectDate={(date) => this._updateStade(idStade, "datePrevisionnelle", Scriba.date().getChaineISOFromDate(date, true))}
                        minDate={minDatePrevisionnelle && new Date(minDatePrevisionnelle)}
                        maxDate={maxDatePrevisionnelle && new Date(maxDatePrevisionnelle)}
                        value={datePrevisionnelle}
                    />
                }
            }
        ];

        const estFicheOuverteEnModeCreation = this._estFicheOuverteEnModeCreation();
        if (!estFicheOuverteEnModeCreation) {

            if (this.state.stades.some(stade => !!stade.dateReelle && !stade.datePrevisionnelle))
                columns.push({
                    iconName: null,
                    isIconOnly: true,
                    key: "sync",
                    minWidth: 20,
                    maxWidth: 20,
                    onRender: (item) => {
                        const { datePrevisionnelle, dateReelle, idStade } = item;
                        if (!!dateReelle && !datePrevisionnelle)
                            return <IconButton
                                iconProps={{ iconName: "DoubleChevronLeft8" }}
                                onClick={() => this._updateStade(idStade, "datePrevisionnelle", dateReelle)}
                                title="Synchroniser la date prévisionnelle"
                            />;
                    }
                });

            columns.push({
                key: "dateReelle",
                minWidth: 150,
                maxWidth: 150,
                name: "Date réelle",
                onRender: (item) => <span>{Scriba.date().stringDateFormatCourt(item.dateReelle)}</span>
            });

        }

        columns.push({
            iconName: null,
            isIconOnly: true,
            key: "delete",
            minWidth: 20,
            maxWidth: 20,
            onRender: (item) => {
                if (!!item.dateReelle) return null;
                else return <IconButton
                    date-testid="deleteEcheancier"
                    iconProps={{ iconName: "Trash" }}
                    onClick={(event) => this._supprimerStade(item.idStade)}
                    title="Retirer le stade de l'échéancier"
                />
            }
        });

        return columns;
    };

    _onDelayedChange = (item) => (event, newValue) => {
        const { autresEcheanciersLies, idStade, pourcentageCumul } = item;
        const newPourcentageCumul = parseFloat(newValue / 100).toFixed(12);

        if (parseFloat(pourcentageCumul).toFixed(12) !== newPourcentageCumul) {
            let callback = null;

            if (autresEcheanciersLies.length > 0) {
                const itemActif = { ...item, autresEcheanciersLies };
                callback = this._toggleDialog("PourcentageCumul", true, itemActif, null);
            }

            this._updateStade(idStade, "pourcentageCumul", newPourcentageCumul, callback);
        }
    };

    _onDismiss = () => {
        const { onDismiss } = this.props;
        const { reloadOnDismiss } = this.state;
        this.setState({ ...FicheEcheancier.defaultState });
        if (!!onDismiss && typeof onDismiss === "function") onDismiss(reloadOnDismiss);
    };

    _onOpen = () => {
        const { idOperation, idEcheancier } = this.props;
        if (!!idOperation && !!idEcheancier) this._chargementDonnees();
    };

    _onVerificationFormulaire = () => {
        const { echeancier, stades } = this.state;
        Immocom.fiche()._validationFormulaire(this, "Echeancier", { ...echeancier, stades }, this._estFicheOuverteEnModeCreation() ? "Création" : "Modification");
    };

    // Le taux est recalculé ici à titre informatif, il sera quoiqu'il arrive recalculé côté serveur avant enregistrement
    _recalculerTaux = (stades) => {
        let cumul = 0;
        stades.sort((a, b) => a.pourcentageCumul - b.pourcentageCumul);
        return stades.map((stade, index) => {
            stade.pourcentageCumul = parseFloat(stade.pourcentageCumul).toFixed(12);
            stade.pourcentageAvancementTravaux = parseFloat(stade.pourcentageCumul - cumul).toFixed(12);
            cumul = stade.pourcentageCumul;
            return stade;
        });
    };

    _supprimerStade = (id) => {
        let newStades = this.state.stades.filter((stade) => stade.idStade !== id);
        newStades = this._recalculerTaux(newStades);
        newStades = this._determinerRangeDatePrevisionnelle(newStades);
        this.setState({ stades: newStades }, this._onVerificationFormulaire);
    };

    _toggleDialog = (nomDialog, isOpen, item, callback) => () => {
        this.setState({
            [`afficherDialog${nomDialog}`]: isOpen,
            itemActif: item || {}
        }, callback);
    };

    _updateEcheancier = (values) => {
        const echeancier = { ...this.state.echeancier, ...values };
        this.setState({ echeancier }, () => {
            window.clearTimeout(this.deferredValidation);
            this.deferredValidation = window.setTimeout(this._onVerificationFormulaire, 500);
        });
    };

    _updateStade = (id, key, value, callback) => {
        let stades = [...this.state.stades];
        let index = stades.findIndex(stade => stade.idStade === id);

        if (index >= 0) {
            let stade = { ...stades[index] };
            if (stade[key] !== value) {
                stade[key] = value;
                stades.splice(index, 1);
                stades.push(stade);
                stades = this._recalculerTaux(stades);
                stades = this._determinerRangeDatePrevisionnelle(stades);
                this.setState(
                    { stades },
                    () => {
                        this._onVerificationFormulaire();
                        if (!!callback && typeof callback === "function") callback();
                    }
                );
            }
        }
    };

    componentDidUpdate = (prevProps) => {
        const { idEcheancier } = this.props;
        if (idEcheancier !== prevProps.idEcheancier) {
            const { SELECTION, EDITION } = FicheEcheancier.STEPS;
            if (!!idEcheancier) this.setState({ currentStep: EDITION });
            else this.setState({ currentStep: SELECTION });
        }
    };

    render = () => {

        const { idEcheancier, idOperation, isOpen } = this.props;
        const {
            afficherDialogAbandon, afficherDialogNomStade, afficherDialogPourcentageCumul,
            currentStep, echeancier, idEcheancierTypeSelectionne, itemActif, minDatePrevisionnelle, maxDatePrevisionnelle, onActiveBoutonEnregistrer, stades
        } = this.state;
        const { SELECTION } = FicheEcheancier.STEPS;

        const estFicheOuverteEnModeCreation = this._estFicheOuverteEnModeCreation();

        if (estFicheOuverteEnModeCreation && currentStep === SELECTION) {
            return <EUIPanel
                headerText="Nouvel échéancier"
                isFormValid={!!idEcheancierTypeSelectionne}
                isOpen={isOpen}
                onDismiss={this._onDismiss}
                onNext={this._chargementDonnees}
                type={PanelType.smallFixedFar}
            >
                {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}
                <Stack>
                    <MessageBars
                        errorMessage={this.state.errorMessage}
                        infoMessage={this.state.messageMessageBarFiltres}
                        warningMessage={this.state.warningMessage}
                        onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                        onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                    />
                    <ComboBoxEcheancier
                        name="comboEcheancier"
                        idOperation={idOperation}
                        inclureEcheancierType
                        inclureNouvelEcheancier
                        onChange={(event, option, index, value, item) => this.setState({ idEcheancierTypeSelectionne: item.idEcheancier })}
                        placeholder="Sélectionnez"
                        selectedKey={idEcheancierTypeSelectionne}
                    />
                </Stack>
            </EUIPanel>;
        }
        else // currentStep === EDITION
        {
            return <EUIPanel
                headerText={estFicheOuverteEnModeCreation ? "Nouvel échéancier" : "Modification d'un échéancier"}
                isFormValid={onActiveBoutonEnregistrer}
                isOpen={isOpen}
                onDismiss={this._onDismiss}
                onOpen={this._onOpen}
                onPrevious={estFicheOuverteEnModeCreation ? this._toggleDialog("Abandon", true, null, null) : null}
                onSave={this._enregistrer}
                type={PanelType.large}
            >

                {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

                <Stack>

                    <MessageBars
                        errorMessage={this.state.errorMessage}
                        infoMessage={this.state.messageMessageBarFiltres}
                        warningMessage={this.state.warningMessage}
                        onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                        onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                    />

                    <EUITextField
                        label="Nom de l'échéancier"
                        name="inputNomEcheancier"
                        maxLength={MaxLengths.echeancier.nomEcheancier}
                        onChange={(event, newValue) => this._updateEcheancier({ nomEcheancier: newValue })}
                        required
                        value={echeancier.nomEcheancier || ""}
                    />

                    <StadeForm
                        estParentOuvertEnModeCreation={estFicheOuverteEnModeCreation}
                        hiddenIds={stades.map(stade => stade.idStade)}
                        idEcheancier={idEcheancier}
                        idOperation={idOperation}
                        minDate={!!minDatePrevisionnelle ? new Date(minDatePrevisionnelle) : StadeForm.defaultProps.minDate}
                        maxDate={!!maxDatePrevisionnelle ? new Date(maxDatePrevisionnelle) : StadeForm.defaultProps.maxDate}
                        onChange={stade => {
                            if (!!stade.pourcentageCumul) {
                                let simulation = [...stades, stade];
                                simulation = this._determinerRangeDatePrevisionnelle(simulation);
                                this.setState({
                                    minDatePrevisionnelle: stade.minDatePrevisionnelle,
                                    maxDatePrevisionnelle: stade.maxDatePrevisionnelle
                                });
                            }
                        }}
                        onEnregistrement={this._ajouterStade}
                    />

                    <EUISeparator />

                    <DetailsList
                        columns={this._getColumns()}
                        items={stades}
                        onRenderRow={(props, defaultRender) => {
                            const styles = concatStyleSets(props.styles, { fields: { alignItems: "center" } });
                            return defaultRender({ ...props, styles });
                        }}
                        selectionMode={SelectionMode.none}
                    />

                </Stack>

                <EUIDialog
                    buttons={[
                        <PrimaryButton key="confirm" onClick={this._toggleDialog("Abandon", false, null, () => this.setState({ ...FicheEcheancier.defaultState }))} text="Abandonner" />,
                        <DefaultButton key="cancel" onClick={this._toggleDialog("Abandon", false, null, null)} text="Reprendre" />
                    ]}
                    isOpen={afficherDialogAbandon}
                    message="Êtes-vous sûr de vouloir abandonner le travail en cours ?"
                    onDismiss={this._toggleDialog("Abandon", false, null, null)}
                    titre="Attention"
                />

                <EUIDialog
                    buttons={[<PrimaryButton key="ok" onClick={this._toggleDialog("PourcentageCumul", false, null, null)} text="OK" />]}
                    isOpen={afficherDialogPourcentageCumul}
                    onDismiss={this._toggleDialog("PourcentageCumul", false, null, null)}
                    titre="Attention"
                >
                    <Text>La mise à jour du pourcentage cumulé de ce stade impactera également les échéanciers suivants :</Text>
                    <ul>
                        {!!itemActif.autresEcheanciersLies &&
                            itemActif.autresEcheanciersLies.reduce((memo, echeancier, index, array) => {
                                if (!!echeancier.nomEcheancier)
                                    memo.push(<li key={index}>{echeancier.nomEcheancier}</li>);
                                return memo;
                            }, [])
                        }
                    </ul>
                </EUIDialog>

                <DialogNomStade
                    idOperation={idOperation}
                    isOpen={afficherDialogNomStade}
                    stade={itemActif}
                    onDismiss={this._toggleDialog("NomStade", false, null)}
                    onEnregistrement={this._toggleDialog(
                        "NomStade", false, null,
                        () => this.setState({ reloadOnDismiss: true }, this._chargementDonnees)
                    )}
                />

            </EUIPanel>;
        }
    };

};